











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { isEmpty, isEqual } from "element-ui/src/utils/util";
@Component({})
export default class extendCascaderPannel extends Vue {
  @Prop({ default: false }) disabled;
  @Prop({ default: "/" }) splitString;
  @Prop({ type: Function }) lazyLoad;
  @Prop({ default: () => {} }) config;
  @Prop({ default: () => [] }) selectedValue;
  visible = false;
  selected = "";
  cascaderValue = [];

  @Watch("selectedValue", { immediate: true })
  watchSelectedValue(val) {
    if (!isEqual(val, this.cascaderValue)) {
      this.cascaderValue = this.selectedValue || [];
      this.selected = "";
    }
  }
  @Watch("cascaderValue", { immediate: true })
  watchCascaderValue(val) {
    this.$emit("update:selectedValue", val);
  }
  get props() {
    let result = {
      lazy: true,
      lazyLoad: this.lazyLoad,
      children: "children",
      label: "label",
      value: "value",
      leaf: "isLeaf",
      ...this.config
    };

    return result;
  }
  computePresentText() {
    let $cascader: any = this.$refs.popCascaderPannel;
    if ($cascader) {
      const { checkedValue, config } = $cascader;
      if (!isEmpty(checkedValue)) {
        const node = $cascader.getNodeByValue(checkedValue);
        if (node && node.isLeaf) {
          this.selected = node.pathLabels.join("/");
          this.$emit("emitDefaultText", this.selected);
        }
      }
    }
  }
  async getPresentText() {
    let $cascader: any = this.$refs.popCascaderPannel;
    let nodes = $cascader.getCheckedNodes();

    if (nodes && nodes.length > 0 && nodes[0]) {
      this.selected = nodes[0].pathLabels.join("/");
    }
    return this.selected;
  }
}
